"use client";

import { useState } from "react";
import Image from "next/image";
import FAIcon from "@/components/icons/faIcon";

const testimonials = [
  {
    quote:
      "SML provided Baxters with interim health and safety support across our European facilities. They were able to provide baseline assessments across the sites along with specific improvement plans. SML were able to mobilise a wide range of experts to understand and tackle specific challenges.",
    author: "Matt Crompton",
    role: "European Manufacturing Director",
    logo: "/images/logo/partners/baxters.svg",
  },
  {
    quote:
      "SML has always provided us with expert impartial and pragmatic analysis, which has helped us to identify our strengths and also highlight areas for future focus.",
    author: "Steve Bradley",
    role: "Group HSE Manager, Associated British Foods PLC",
    logo: "/images/logo/partners/associated-british-foods-logo.svg",
  },
  {
    quote:
      "We have worked with SML for numerous years. They offer a great service with the expertise needed to offer everything to fully comply in an ever changing world. I would have no reservation about recommending SML to anyone.",
    author: "James Pacifici",
    role: "Abbeymill Homes",
    logo: "/images/logo/partners/abbey-mill.svg",
  },
];

export default function AssessmentTestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const testimonial = testimonials[activeIndex];

  function showPrevious() {
    setActiveIndex((currentIndex) =>
      currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1,
    );
  }

  function showNext() {
    setActiveIndex((currentIndex) =>
      currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1,
    );
  }

  return (
    <section className="bg-white px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-328 overflow-hidden rounded-2xl bg-[#fafafa] px-6 py-12 sm:px-10 lg:px-12">
        <h2 className="text-center font-raleway text-[2.125rem] font-medium leading-[1.3] tracking-[-0.06em] text-[#06040c]">
          Our clients say
        </h2>

        <div className="relative mt-16 overflow-hidden">
          <div className="pointer-events-none absolute bottom-12 left-0 top-0 hidden w-[48%] items-center justify-center p-8 opacity-65 sm:flex lg:p-12">
            <div className="w-full max-w-64">
              <Image
                src="/images/assessment/assessment-logo.png"
                alt=""
                width={520}
                height={340}
                className="h-auto w-full object-contain"
              />
            </div>
          </div>

          <article
            key={testimonial.author}
            className="relative ml-auto flex min-h-[21rem] max-w-2xl flex-col justify-between px-1 pb-12 sm:w-[62.5%] sm:px-0"
            aria-live="polite"
          >
            <div>
              <Image
                src="/images/assessment/quotes.svg"
                alt=""
                width={51}
                height={45}
                className="h-11 w-auto"
              />
              <p className="mt-10 font-raleway text-[1.25rem] font-medium leading-[1.4] tracking-[-0.04em] text-[#06040c] sm:text-[1.38rem]">
                {testimonial.quote}
              </p>
            </div>

            <div className="flex items-end justify-between gap-6 border-t border-[#06040c]/12 pt-5">
              <div>
                <p className="font-raleway text-base font-semibold text-[#06040c]">
                  {testimonial.author}
                </p>
                <p className="mt-1 text-sm leading-5 text-[#06040c]/55">{testimonial.role}</p>
              </div>
              <Image
                src={testimonial.logo}
                alt=""
                width={120}
                height={48}
                className="h-10 w-auto max-w-[120px] object-contain opacity-60"
              />
            </div>
          </article>

          <div className="absolute bottom-0 left-0 flex gap-2">
            <button
              type="button"
              onClick={showPrevious}
              aria-label="Previous testimonial"
              className="flex h-10 w-10 items-center justify-center border border-[#06040c]/20 text-[#06040c] transition-colors hover:bg-[#06040c] hover:text-white"
            >
              <FAIcon icon="arrow-right" size={15} noMargin className="rotate-180" />
            </button>
            <button
              type="button"
              onClick={showNext}
              aria-label="Next testimonial"
              className="flex h-10 w-10 items-center justify-center border border-[#06040c]/20 text-[#06040c] transition-colors hover:bg-[#06040c] hover:text-white"
            >
              <FAIcon icon="arrow-right" size={15} noMargin />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}